import { useEffect, useRef } from "react";
import { Search, ChevronUp, ChevronDown, X } from "lucide-react";
import "./ChatSearchBar.css";

export default function ChatSearchBar({
  query,
  setQuery,
  total,
  position,
  onPrev,
  onNext,
  onClose,
}) {
  const inputRef = useRef(null);

  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  const onKeyDown = (e) => {
    if (e.key === "Escape") onClose();
    if (e.key === "Enter") (e.shiftKey ? onPrev : onNext)();
  };

  const hasQuery = query.trim().length > 0;

  return (
    <div className="csb">
      <div className="csb__field">
        <Search size={16} className="csb__icon" />
        <input
          ref={inputRef}
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          onKeyDown={onKeyDown}
          placeholder="Search in chat…"
        />
        {hasQuery && (
          <span className="csb__count">
            {total > 0 ? `${position + 1} of ${total}` : "No results"}
          </span>
        )}
      </div>

      <button
        className="csb__btn"
        onClick={onPrev}
        disabled={total === 0}
        title="Previous"
      >
        <ChevronUp size={18} />
      </button>
      <button
        className="csb__btn"
        onClick={onNext}
        disabled={total === 0}
        title="Next"
      >
        <ChevronDown size={18} />
      </button>
      <button className="csb__btn" onClick={onClose} title="Close search">
        <X size={18} />
      </button>
    </div>
  );
}
